import { memo, useCallback } from "react";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

import { FormFieldLayout } from "../../layouts";

type Props = {
	// キャンセル不可のディスカウント
	isUncancelable: boolean;
	// キャンセル不可のディスカウントにするかの変更
	onChangeIsUncancelable: (value: boolean) => void;
};

export const IsUncancelableFormFieldComposition = memo(({ isUncancelable, onChangeIsUncancelable }: Props) => {
	/**
	 * キャンセル不可のディスカウントにするかの変更
	 */
	const handleChangeIsUncancelable = useCallback(
		(value: boolean) => {
			onChangeIsUncancelable(value);
		},
		[onChangeIsUncancelable],
	);

	return (
		<FormFieldLayout title="キャンセル不可のディスカウント">
			<CheckboxField
				value={isUncancelable}
				label="キャンセル不可のディスカウントにする"
				handleChange={handleChangeIsUncancelable}
			/>

			<div className="mt-2">
				<p className="whitespace-pre-wrap text-sm text-caption-50">
					{`予約の日程やオプションの変更が不可能なディスカウントプランを作成できます。`}
				</p>
			</div>
		</FormFieldLayout>
	);
});
